import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgBumpIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M25.585 3H2.414C1.086 3 0 4.099 0 5.442v17.516C0 24.302 1.086 25.4 2.414 25.4h23.171c1.33 0 2.415-1.099 2.415-2.442V5.442C28 4.098 26.914 3 25.585 3zM6.104 22.39c0 .82-.657 1.484-1.466 1.484a1.473 1.473 0 0 1-1.466-1.484v-5.834c0-.819.656-1.481 1.466-1.481.81 0 1.466.662 1.466 1.481v5.834zm7.19 0c0 .82-.656 1.484-1.465 1.484a1.473 1.473 0 0 1-1.466-1.484v-5.834c0-.819.656-1.481 1.466-1.481.809 0 1.465.662 1.465 1.481v5.834zm11.64-11.242a1.454 1.454 0 0 1-2.072 0L21.51 9.784v12.607c0 .82-.658 1.484-1.466 1.484a1.474 1.474 0 0 1-1.466-1.484V9.781l-1.345 1.378a1.448 1.448 0 0 1-1.043.441 1.45 1.45 0 0 1-1.03-.425 1.494 1.494 0 0 1-.013-2.098l4.87-4.995 4.916 4.967c.574.579.574 1.518.001 2.098v.001z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBumpIcon;
